
let information = [
  {
    path: 'information',
    name: '会员信息管理',
    component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
    children: [
      {
        path: 'member',
        component: () => import("@/views/admin/member/information/memberG/index.vue"),
        name: '会员管理',
        meta: {
          hidden: true,
          key: 4001
        },
      },
      {
        path: 'clock',
        component: () => import("@/views/admin/member/information/clock/index.vue"),
        name: '会员打卡',
        meta: {
          hidden: true,
          key: 4011
        },
      },
      {
        path: 'member/user/:id',
        component: () => import("@/views/admin/member/information/memberG/user/index.vue"),
        name: '会员详情',
        meta: {
          hidden: true,
          key: 4001,
          isShow: false
        },
      },
      {
        path: 'member-grouping',
        component: () => import("@/views/admin/member/information/grouping/index.vue"),
        name: '会员分组',
        meta: {
          hidden: true,
          key: 4002
        },
      },
      {
        path: 'label',
        component: () => import("@/views/admin/member/information/label/index.vue"),
        name: '会员标签',
        meta: {
          hidden: true,
          key: 4009
        },
      },


      {
        path: 'member-grade',
        component: () => import("@/views/admin/member/information/grade/index.vue"),
        name: '会员等级',
        meta: {
          hidden: true,
          key: 4005
        },
      },
      {
        path: 'erp-manage',
        component: () => import("@/views/admin/member/information/erp-manage/index.vue"),
        name: '企业ERP',
        meta: {
          hidden: true,
          key: 4012
        },
      },
    ]
  }
]



let integral = [
  {
    path: 'integral',
    name: '会员积分管理',
    component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
    children: [
      {
        path: 'member-integral',
        component: () => import("@/views/admin/member/integral/supervise/index.vue"),
        name: '会员积分',
        meta: {
          hidden: true,
          key: 4003
        },
      },
      {
        path: 'member-rule',
        component: () => import("@/views/admin/member/integral/integral-rule/index.vue"),
        name: '积分规则',
        meta: {
          hidden: true,
          key: 4004
        },
      },
    ]
  }
]


let gocardless = [
  {
    path: 'gocardless',
    name: '会员卡卷管理',
    component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
    children: [
      {
        path: 'marketing',
        component: () => import("@/views/admin/member/gocardless/marketing/index.vue"),
        name: '会员营销',
        meta: {
          hidden: true,
          key: 4010
        },
      },
    ]
  }
]

let consumption = [
  {
    path: 'consumption',
    name: '会员消费管理',
    component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
    children: [
      {
        path: 'advanceDeposit',
        component: () => import("@/views/admin/member/consumption/advance-deposit/index.vue"),
        name: '预存款管理',
        meta: {
          hidden: true,
          key: 4008
        },
      },
      // {
      //   path: 'statistics',
      //   component: () => import("@/views/admin/member/consumption/statistics/index.vue"),
      //   name: '会员消费统计',
      //   meta: {
      //     hidden: true,
      //     key:4008
      //   },
      // },

    ]
  }
]

export const member = [
  {
    path: '/member',
    name: '会员系统',
    redirect: '/member/wares',
    component: () => import("@/views/layout/index.vue"),
    children: [
      ...information,//会员信息管理
      ...gocardless,//卡卷管理
      ...integral,//会员积分管理
      ...consumption
    ]
  },

]
